import {Component, OnInit} from '@angular/core';
import {SimulationsService} from "../../components/simulation-list/simulations.service";
import {MatDialogRef} from "@angular/material";

@Component({
    selector: 'app-solutions-edit-table',
    templateUrl: './solutions-edit-table.component.html',
    styleUrls: ['./solutions-edit-table.component.css']
})
export class SolutionsEditTableComponent implements OnInit {

    public tableColumns;

    constructor(public dialogRef: MatDialogRef<SolutionsEditTableComponent>, private simulationsService: SimulationsService) {
        this.tableColumns = simulationsService.tableMetaData;
    }

    ngOnInit() {
    }

    close() {
        this.dialogRef.close(this.tableColumns);
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/dialogs/solutions-edit-table/solutions-edit-table.component.ts